<template>
  <v-application v-if="access.setting_currency">
    <v-settings>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t("currency") }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          v-if="edit_currency == false"
          icon
          color="primary"
          @click="edit_currency = true"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form v-model="is_valid">
        <v-card-text>
          <v-layout row px-2>
            <v-flex md4 px-2>
              <v-text-field type="number" :value="1" suffix="$" readonly />
            </v-flex>
            <v-flex md2 px-2>
              <vuetify-money
                v-model="currency.value"
                v-bind:options="moneyOptions"
                :rules="[fieldRules.require]"
                :readonly="edit_currency == false"
              />
            </v-flex>
            <v-flex md2 px-2>
              <v-text-field
                v-model="currency.number_of_zero"
                :readonly="edit_currency == false"
                :rules="[fieldRules.require]"
              />
            </v-flex>
            <v-flex md4 px-2>
              <v-select
                v-model="currency.currency"
                :label="'Actual currency'"
                :items="currencies"
                :readonly="edit_currency == false"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <template #actions v-if="edit_currency">
        <v-btn text v-on:click="currency_cancel">{{ $t("cancel") }}</v-btn>
        <v-btn
          text
          color="primary"
          v-on:click="update_currency"
          :disabled="!is_valid || !currency.value > 0"
          >{{ $t("save") }}</v-btn
        >
      </template>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>

<script>
import Currency from "../../mixins/settings/currency";
export default {
  name: "SettingsCurrency",
  mixins: [Currency],
  data: () => ({
    edit_currency: false,
    is_valid: false,
  }),
  methods: {
    currency_cancel() {
      this.get_currency();
      this.edit_currency = false;
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
